import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { ContentFilter, QuickFeedback } from '..'
import { RelatedSidebarContainer } from '../../containers'

const FAQContent = ({ name, text, faqId, createUserEvent }) => {
  return (
    <Fragment>
      <div className="faq-text">
        <ContentFilter text={text} name={name} />
      </div>
      <div className="faq-clear" />
      <QuickFeedback
        type="faqs"
        contentId={faqId}
        createUserEvent={createUserEvent}
      />
      <RelatedSidebarContainer
        relatedType="suggested"
        contentType="faq"
        id={faqId}
      />
    </Fragment>
  )
}

FAQContent.propTypes = {
  name: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  createUserEvent: PropTypes.func.isRequired,
  faqId: PropTypes.number.isRequired
}

export default FAQContent



// WEBPACK FOOTER //
// ./src/components/FAQ/FAQContent.js